import { render, staticRenderFns } from "./Continue.vue?vue&type=template&id=964f982a"
import script from "./Continue.vue?vue&type=script&lang=js"
export * from "./Continue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports